<template>
  <span class="spinner-playing">
    <span class="spinner-playing__bars">
      <span class="spinner-playing__bar spinner-playing__bar--left" />
      <span class="spinner-playing__bar spinner-playing__bar--center" />
      <span class="spinner-playing__bar spinner-playing__bar--right" />
    </span>
  </span>
</template>

<style lang="scss" scoped>
@keyframes animloader {
  0% {
    height: 1em;
  }
  100% {
    height: 0.2em;
  }
}

.spinner-playing {
  font-size: 1em;
  position: relative;
  display: block;
  width: 1em;
  height: 1em;

  &__bars {
    position: absolute;
    left: 50%;
    top: 50%;
    display: block;
    font-size: 0.8em;
    width: 1em;
    height: 1em;
    transform: translate(-50%, -50%);
  }

  &__bar {
    position: absolute;
    top: 50%;
    display: block;
    width: 0.2em;
    height: 1em;
    border-radius: 1em;
    background: currentColor;
    animation: animloader 0.3s 0.3s linear infinite alternate;
    transform: translateY(-50%);

    &--left {
      left: 0;
      animation-delay: 170ms;
    }

    &--center {
      left: 50%;
      transform: translate(-50%, -50%);
    }

    &--right {
      right: 0;
      animation-delay: 50ms;
    }
  }
}
</style>
